import { render, staticRenderFns } from "./TreeselectExtended.vue?vue&type=template&id=79266b5a&scoped=true"
import script from "./TreeselectExtended.vue?vue&type=script&lang=js"
export * from "./TreeselectExtended.vue?vue&type=script&lang=js"
import style0 from "./TreeselectExtended.vue?vue&type=style&index=0&id=79266b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79266b5a",
  null
  
)

export default component.exports